import { useEffect, useState } from 'react'
import styled from "styled-components";
import { getCookie } from "./components/helpers"
import { showDisclaimer } from "@templateroller/helpers/dist/api/requests"

const slots = [
    '3402756130',
    '7149417699',
    '5836336025',
]

const AdBlock = styled.div<{
    readonly width?: string
    readonly height?: string
    readonly margin?: string
}>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    width: ${props => props.width ? props.width : '100%'};
    height: ${props => props.height ? props.height : 'auto'};
    margin: ${props => props.margin ? props.margin : '0'};
    padding-bottom: 18px;

    color: #bbbbbb;
    font-size: 12px;
    line-height: 36px;
    font-weight: 500;
    background-color: #ffffff;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 1;
`
AdBlock.displayName = 'AdBlock'

const AdWrapper = styled.div`
    width: 100%;
    height: auto;
    border-top: 1px solid #bbbbbb99;
    border-bottom: 1px solid #bbbbbb99;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 1;
    padding: 6px 0;
`

// const VerticalAdMock = ({ adNum }: Props) => {
//     return (
//         <img src={`https://via.placeholder.com/164x600`} />
//     )
// }

type Props = {
    adNum: number,
    width?: string,
    height?: string,
    margin?: string,
}

const VerticalAd = ({ adNum, width, height, margin }: Props) => {
    // const [optnow, setOptnow] = useState<boolean | undefined>(undefined)

    useEffect(() => {
        //@ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});

        // const ccpa = getCookie('ccpa')
        // if (ccpa === 'optnow') setOptnow(true)
        // else if (!!ccpa) setOptnow(false)
        // else showDisclaimer().then(e => {
        //     if (e.status === 'ccpa') setOptnow(true)
        //     else setOptnow(false)
        // })
    }, [])

    // useEffect(() => {
    //     if (typeof optnow !== 'undefined') {
    //         //@ts-ignore
    //         (window.adsbygoogle = window.adsbygoogle || []).push({});
    //     }
    // }, [optnow])

    // if (optnow === undefined) return null
    return <AdBlock
        className={"ad-block ad-" + adNum}
        width={width}
        height={height}
        margin={margin}
    >
        <div>ADVERTISMENT</div>
        <AdWrapper>
            <ins className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-4225178227804431"
                data-ad-slot={slots[adNum]}
                data-ad-format="auto"
                data-full-width-responsive="true"
                // {...(optnow ? {"data-restrict-data-processing": "1"} : {})}
            ></ins>
        </AdWrapper>
    </AdBlock>
}

//const node_env = process.env.REACT_APP_ENV
//const Ad = !node_env | node_env === 'development' ? VerticalAdMock : VerticalAd
const Ad = VerticalAd

export default Ad